import React from 'react';

export default function Nose() {
	return (
		<g>
			<path className="fill fill--alt--dark" d="M245.56143,207.01997c0,3.7489-3.28592,6.78799-7.33931,6.78799s-7.33931-3.03909-7.33931-6.78799" />
			<path className="fill fill--alt" d="M230.88281,207.01997c0-6.18192,2.01007-9.74736,7.33931-9.74736s7.33931,3.56544,7.33931,9.74736
				l-7.33931,1.44598L230.88281,207.01997z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Chicken/Nose.js